var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"inset":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"  "),_c('v-icon',{attrs:{"size":"18"}},[_vm._v("lock")])]},proxy:true}]),model:{value:(_vm.dummyFlag),callback:function ($$v) {_vm.dummyFlag=$$v},expression:"dummyFlag"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b6809d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","svgicon":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/LockedFeatureSwitch.vue
// module id = null
// module chunks = 